export default __webpack_public_path__ + "static/media/sienas1-min.46e005ec.jpg";